import ticketDetails from '../localization-messages/ticketDetails/fr-BE.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/fr-BE.json';
import ticketListing from '../localization-messages/ticketListing/fr-BE.json';
import ticketForm from '../localization-messages/ticketForm/fr-BE.json';
import headerFooter from '../localization-messages/headerFooter/fr-BE.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/fr-BE.json';
import termsModal from '../localization-messages/termsModal/fr-BE.json';

export const frBETranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
